import React, { VoidFunctionComponent } from "react";

interface Props {
  index: number;
  detail: string;
}
const hasCheckMark = (index: number): boolean => index > 0;

export const DetailsItem: VoidFunctionComponent<Props> = ({ detail, index }) => (
  <div key={index} className="layer-warranty-details-item">
    {hasCheckMark(index) && <img src={"/assets/images/responsive/icons/checkmark.svg"} alt={"icone case cochée "} />}
    <p dangerouslySetInnerHTML={{ __html: detail }}></p>
  </div>
);